import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  legend: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '1rem'
  },
  square: {
    width: '0.5rem',
    minWidth: '0.5rem',
    height: '0.5rem',
    marginRight: '1rem',
    borderRadius: '50%'
  }
});

interface Props {
  color: string;
  text: string;
}

const LegendItem = ({ color, text }: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.legend}>
      <div style={{ backgroundColor: color }} className={classes.square} />
      <span>{text}</span>
    </div>
  );
};

export default LegendItem;
